import { Injectable } from '@angular/core';
import { CameraPreview, CameraPreviewOptions } from '@capacitor-community/camera-preview';
import '@capacitor-community/camera-preview';
import { ModalController } from '@ionic/angular';
import { CameraComponent } from './camera.component';
import { TCameraModel } from './model/camera.types';
import { TBucketInfo } from '../bucket-storage.types';
@Injectable({
  providedIn: 'root',
})
export class CameraService {
  constructor(private modalController: ModalController) {}

  /**
   * Open Camera Model to start capturing images and preview them
   * @param cameraModel
   * @returns
   */
  async openModal(cameraModel: TCameraModel) {
    const modal = await this.modalController.create({
      component: CameraComponent,
      componentProps: {
        CAMERA_MODEL: cameraModel,
      },
      cssClass: 'm-modal_camera_component',
      backdropDismiss: false,
    });
    modal.present();

    return await modal.onDidDismiss<TBucketInfo>();
  }

  /**
   * Start Camera inside the modal, after view is rendered
   * @param boundedRect Container rect to set dimention of the camera viewport
   * @returns
   */
  async start(boundedRect: DOMRect) {
    //Without Math.ceil => due to floating point issues between javascript and android java code,
    //camera alignment is not proper
    const cameraPreviewOptions: CameraPreviewOptions = {
      position: 'rear',
      parent: 'cameraPreview',
      width: Math.ceil(boundedRect.width),
      height: Math.ceil(boundedRect.height),
      x: Math.ceil(boundedRect.x),
      y: Math.ceil(boundedRect.y),
      storeToFile: true, // return uri inside Cache folder
      enableOpacity: true,
      enableZoom: true,
    };
    return CameraPreview.start(cameraPreviewOptions);
  }

  /**
   * Stop Camera
   * @returns Promise<empty>
   */
  async stop() {
    return CameraPreview.stop();
  }

  /**
   * Take Photo
   * @param cameraMode
   * @returns uri of the image store in Cache
   */
  async takePhoto() {
    const result = await CameraPreview.capture({
      quality: 90,
    });
    const uri = result.value; // value is uri
    return uri;
  }
}
